import { useState } from 'react';
import { analysisMetrics } from '@/mocks/homeData';

const barColors = ['bg-primary-500', 'bg-accent-500', 'bg-secondary-500', 'bg-foreground-400'];

export default function HorizontalAnalysis() {
  const [activeIndex, setActiveIndex] = useState(0);
  const metric = analysisMetrics[activeIndex];

  return (
    <section id="analysis" className="w-full bg-foreground-950 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-2xl mb-10 md:mb-14">
          <span className="text-xs font-medium tracking-widest text-accent-400 uppercase">
            横向比较分析
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mt-3 mb-4">
            用指标量化差异，而不是凭印象判断
          </h2>
          <p className="text-sm md:text-base text-foreground-300 leading-relaxed">
            我们为每组对比事件设置统一维度并打分，让"谁传播更广""谁周期更长"这类问题有可对照的依据。
            点击左侧维度即可切换观察视角。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10">
          <div className="lg:col-span-4">
            <div className="flex flex-col gap-2">
              {analysisMetrics.map((item, index) => {
                const isActive = index === activeIndex;
                return (
                  <button
                    key={item.label}
                    type="button"
                    onClick={() => setActiveIndex(index)}
                    className={`text-left p-4 rounded-lg border transition-colors cursor-pointer ${
                      isActive
                        ? 'bg-background-50 border-background-50'
                        : 'bg-foreground-900 border-foreground-800 hover:border-foreground-700'
                    }`}
                  >
                    <div
                      className={`font-heading text-base font-semibold ${
                        isActive ? 'text-foreground-950' : 'text-background-100'
                      }`}
                    >
                      {item.label}
                    </div>
                    <div className={`text-xs mt-1 ${isActive ? 'text-foreground-600' : 'text-foreground-400'}`}>
                      {item.desc}
                    </div>
                  </button>
                );
              })}
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="bg-foreground-900 border border-foreground-800 rounded-lg p-5 md:p-8">
              <div className="flex items-center justify-between mb-6">
                <h3 className="font-heading text-lg font-semibold text-background-50">
                  {metric.label} · 四案例对照
                </h3>
                <span className="text-xs text-foreground-400 whitespace-nowrap">满分 100</span>
              </div>

              <div className="flex flex-col gap-6">
                {metric.values.map((value, index) => (
                  <div key={value.name}>
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-sm text-background-100">{value.name}</span>
                      <span className="text-sm font-medium text-background-50">{value.score}</span>
                    </div>
                    <div className="h-2.5 w-full rounded-full bg-foreground-800 overflow-hidden">
                      <div
                        className={`h-full rounded-full ${barColors[index % barColors.length]} transition-all duration-700`}
                        style={{ width: `${value.score}%` }}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>

              <p className="text-xs text-foreground-400 leading-relaxed mt-6 pt-5 border-t border-foreground-800">
                分数由信息完整度、公开讨论量与后续可验证程度综合计算，仅用于同一维度内的相对比较，
                不跨维度直接累加。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}